import React, { Component } from 'react';
import classNames from 'classnames';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Field } from 'redux-form';
import { Grid, Row, Col, Panel, Button, ButtonToolbar, Breadcrumb, Tabs, Tab, Dropdown, MenuItem } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';
import moment from 'moment';
import { debounce } from 'lodash';

import ContentWrapper from '../Layout/ContentWrapper';
import Spinner from '../Widgets/spinner';
import GenericProductSuggest from '../../containers/Common/GenericProductSuggest';
import TypeRadios from '../../containers/Common/TypeRadios';
import { DatePicker } from '../Common/datePicker';
import { Selection } from '../Common/selection';
import { InputField, DisabledInputField } from '../Common/inputField';
import InventoryInfo from '../../containers/Purchase/inventoryInfo';
import { dateFormat, toFromDates } from '../Common/cleanDates';
import DateFormatter from '../Common/dateFormat';
import CashFormatter from '../Common/cashFormatter';
import checkPermission from '../Common/permissions';
import genericRadioFilter from '../Common/genericRadioFilter';
import dateFilterRadios from '../Common/dateFilterRadios';
import {
  ROOT_URL, companyCodeTitle, isOCM, isOLG, isSUN, isSV, isVAK, isLAP, isAPD, isGGI, isCCW,
} from '../../actions/root_url';
import { PRODUCT_DEP_URL, PURCHASE_URL } from '../../actions/url'
import { isDst } from '../Common/NumberUtil';
import { APP_COLORS } from '../Common/constants';
import GenericSelection from '../Common/GenericSelection';
import axios from 'axios';

const styles = {
  titleLabel: {
    width: '65px',
    paddingTop: '4px',
    fontWeight: 'bold',
  },
  titleField: {
    width: '100px',
    marginRight: '10px',
  },
}
const getBsStyle = (input, value) => (input == value ? 'success' : 'primary');

const renderRadios = (props) => {
  const titleClass = classNames({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'col-xs-2');

  return (
    <ButtonToolbar className="radio-filter-buttons">
      <Button bsStyle={getBsStyle(props.input.value, '1')}>
        <div className="radio">
          <label htmlFor="today-radio-filter">
            <input {...props.input} id="today-radio-filter" type="radio" disabled={(props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading)} name="dateFilterRadios" value="1" onClick={() => props.fetchPurchasingPerformance(1)} checked={props.input.value === '1'} />
            <Translate value="today" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '7')}>
        <div className="radio">
          <label htmlFor="sevenDay-radio-filter">
            <input {...props.input} id="sevenDay-radio-filter" type="radio" disabled={(props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading)} name="dateFilterRadios" value="7" onClick={() => props.fetchPurchasingPerformance(7)} checked={props.input.value === '7'} />
              7 <Translate value="days" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '30')}>
        <div className="radio">
          <label htmlFor="thirtyDay-radio-filter">
            <input {...props.input} id="thirtyDay-radio-filter" type="radio" disabled={(props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading)} name="dateFilterRadios" value="30" onClick={() => props.fetchPurchasingPerformance(30)} checked={props.input.value === '30'} />
              30 <Translate value="days" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '90')}>
        <div className="radio">
          <label htmlFor="ninetyDay-radio-filter">
            <input {...props.input} id="ninetyDay-radio-filter" type="radio" disabled={(props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading)} name="dateFilterRadios" value="90" onClick={() => props.fetchPurchasingPerformance(90)} checked={props.input.value === '90'} />
              90 <Translate value="days" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '-1')}>
        <div className="radio">
          <label htmlFor="dateRange-radio-filter">
            <input {...props.input} id="dateRange-radio-filter" type="radio" disabled={(props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading)} name="dateFilterRadios" value="-1" checked={props.input.value === '-1'} />
            <Translate value="date_range" />
          </label>
        </div>
      </Button>
      <Button bsStyle="primary">
        <Field name="fromDate" disabled={props.input.value !== '-1' || (props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading)} component={DatePicker} placeholder="Start" />
      </Button>
      <Button bsStyle="primary">
        <Field name="toDate" disabled={props.input.value !== '-1' || (props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading)} component={DatePicker} placeholder="End" />
      </Button>
    </ButtonToolbar>
  );
};

const renderPORadios = (props) => {
  const titleClass = classNames({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'col-xs-4');
  return (
    <ButtonToolbar className="radio-filter-buttons">
      <Button bsStyle={getBsStyle(props.input.value, 'All')}>
        <div className="radio">
          <label htmlFor="all-radio-filter">
            <input
              {...props.input}
              id="all-radio-filter"
              type="radio"
              name="statusFilterRadios"
              disabled={(props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading)}
              value="All"
              checked={props.input.value === 'All'}
              onClick={() => {
                /*
                  - Intended to not pass handleOnClick as a function to onClick
                  - handleOnClick needs an undefined value for @param days
                  - this rule should apply to all the buttons here inside renderPORadios
                */
                props.handleOnClick("All");
              }}
            />
            <Translate value="all" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, 'Received')}>
        <div className="radio">
          <label htmlFor="received-radio-filter">
            <input
              {...props.input}
              id="received-radio-filter"
              type="radio"
              name="statusFilterRadios"
              disabled={(props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading)}
              value="Received"
              checked={props.input.value === 'Received'}
              onClick={() => { props.handleOnClick("Received"); }}
            />
            <Translate value="received" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, 'Return')}>
        <div className="radio">
          <label htmlFor="received-radio-filter">
            <input
              {...props.input}
              id="received-radio-filter"
              type="radio"
              name="statusFilterRadios"
              disabled={(props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading)}
              value="Received"
              checked={props.input.value === 'Return'}
              onClick={() => { props.handleOnClick("Return"); }}
            />
            <Translate value="return" />
          </label>
        </div>
      </Button>
    </ButtonToolbar>
  );
};

const renderProductTypeRadios = props => (
  <div className="form-group" id="search-product-by">
    <label className="col-xs-3 search-by-max-width">
      <Translate value="search_by" />
    </label>
    <label className="col-xs-2" >
      <input
        {...props.input}
        type="radio"
        value="ProductNum"
        checked={props.input.value === 'ProductNum'}
      />
      <Translate value="prod_num" />
    </label>
    <label className="col-xs-2 pl">
      <input
        {...props.input}
        type="radio"
        value="RefNum"
        checked={props.input.value === 'RefNum'}
      />
      <Translate value={isOLG ? "item_no" : "ref_num"} />
    </label>
    <label className="col-xs-2" >
      <input
        {...props.input}
        type="radio"
        value="Name"
        checked={props.input.value === 'Name'}
      />
      <Translate value="name" />
    </label>
    <label className="ml-lg" >
      <input
        {...props.input}
        type="radio"
        value="Description"
        checked={props.input.value === 'Description'}
      />
      <Translate value="description" />
    </label>
  </div>
);
class PurchasingPerformanceNew extends Component {
  constructor() {
    super();
    this.state = {
      purchasingPerformance: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      purchaseOrderDetail: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      purchasingPerformanceByProducts: {
        rows: [],
        selectedRows: [],
        sortColumn: null,
        sortDirection: null,
        selectedIndexes: [],
      },
      SumPO: 0,
      activeKey: 1,
      showInventoryOpen: false,
      selectedInventoryRow: [],
      ProductNum: 0,
      days: '7',
      fromDate: undefined,
      toDate: undefined,
      suggestValue: '',
      productSearchType: 'ProductNum',
      totalPriceByPO: 0,
      finalPriceByPO: 0,
      totalPriceByProd: 0,
      totalQtyByProd: 0,
      totalQty: 0,
      totalWt: 0,
      receiveTotalQtyByProd: 0,
      //for generic radio filter
      POStatus: 'All',
      orderType: null,
      currentGroup: null,
      currentCategory: null,
      depExpanded: false,
      groupExpanded: false,
      currentDep: -1,
      buyerOptions: [],
      selectedBuyer: 'All',
      deps: [],
      hide: false,
      checkable: false,
      checkedDepKeys: [],
      checkedDepKeysCopy: [],
      checkedGroupKeys: [],
      checkedGroupKeysCopy: [],
      checkedCategoryKeys: []
    };
    this.fetchPurchasingPerformanceByDays = this.fetchPurchasingPerformanceByDays.bind(this);
    this.fetchPurchasingPerformanceByStatus = this.fetchPurchasingPerformanceByStatus.bind(this);
    this.openShowInventory = this.openShowInventory.bind(this);
    this.closeShowInventory = this.closeShowInventory.bind(this);
    this.selectInventoryInfo = this.selectInventoryInfo.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.setUnitPrice = this.setUnitPrice.bind(this);
    this.setAllProductQuantity = this.setAllProductQuantity.bind(this);
  }

  componentWillMount() {
    this.props.setDefaultOfForm('days', '7', 'purchasingPerformance');
    this.props.setDefaultOfForm('POStatus', 'All', 'purchasingPerformance');
    this.props.setDefaultSearchType('RefNum', 'purchasingPerformance');
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    if (this.props.selectedCompany && this.props.selectedCompany.value) {
      this.props.fetchVendors(checkPermission('vendors_manager') ? {Company_id: undefined} : {});
    }
    if (((isLAP || isAPD) || isGGI) && !this.props.Vendor_id) {
      this.fetchListWithFilters();
    }
    this.props.fetchDeps();
    this.props.fetchPurchaser()
  }

  componentWillReceiveProps(nextProps) { 
    if (nextProps.purchaserList && nextProps.purchaserList !== this.props.purchaserList) {
      let buyerOptions = [{value: "All", label: "All Buyers"}];
      if (nextProps.purchaserList && nextProps.purchaserList.length > 0){
        nextProps.purchaserList.map((item) => {
          buyerOptions.push({label: item.username, value: item.BaseUser_id});
        });
        this.setState({
          buyerOptions,
          selectedBuyer: 'All'
        })
      }
    }
    if (nextProps.deps && nextProps.deps !== this.props.deps) {
      let productDepartment_id = nextProps.deps.length ? nextProps.deps[0].ProductDepartment_id : -1;
      let fromDate = '1900-01-01';
      let toDate = '3000-01-01';
      let store = this.props.Store;
      if (store) {
        store = store.value || store;
      }
      if (this.state.fromDate) {
        fromDate = this.formatDate(this.state.fromDate);
      }
      if (this.state.toDate) {
        toDate = this.formatDate(this.state.toDate);
      }
      let currentDepVal = this.state.currentDep !== -1 ? this.state.currentDep : productDepartment_id
      this.setState({ currentDep: currentDepVal }, () => {
        let currentDep = this.state.currentDep;
        if(currentDep === -1) {
          currentDep = null;
        }
        this.fetchListWithFilters();
      });
    }
    if (nextProps.groups && nextProps.groups !== this.props.groups) {
      if (nextProps.groups.length) {
        let checkedGroupKeys = [...this.state.checkedGroupKeys]
        if (this.state.checkedDepKeys.includes(nextProps.groups[0].ProductDepartment_id_id)) {
          nextProps.groups.map(item => {
            checkedGroupKeys.push(item.ProductGroup_id)
          })
        } else {
          nextProps.groups.map(groupItem => {
            checkedGroupKeys = checkedGroupKeys.filter(item => item !== groupItem.ProductGroup_id)
          })
          
        }
        checkedGroupKeys = Array.from(new Set(checkedGroupKeys))
        this.setState({
          checkedGroupKeys
        }, () => {
          this.fetchListWithFilters();
        })
      }
    }
    if (nextProps.groupCategories && nextProps.groupCategories !== this.props.groupCategories) {
      if (nextProps.groupCategories.length) {
        let checkedCategoryKeys = [...this.state.checkedCategoryKeys]
        if (this.state.checkedGroupKeys.includes(nextProps.groupCategories[0].ProductGroup_id_id)) {
          nextProps.groupCategories.map(item => {
            checkedCategoryKeys.push(item.ProductCategory_id)
          })
        } else {
          nextProps.groupCategories.map(item => {
            checkedCategoryKeys = checkedCategoryKeys.filter(categoryItem => categoryItem !== item.ProductCategory_id)
          })
          
        }
        checkedCategoryKeys = Array.from(new Set(checkedCategoryKeys))
        this.setState({
          checkedCategoryKeys
        }, () => {
          this.fetchListWithFilters();
        })
      }
    }
    if (nextProps.purchasingPerformance && nextProps.purchasingPerformance != this.props.purchasingPerformance) {
      const purchasingPerformance = { ...this.state.purchasingPerformance, rows: nextProps.purchasingPerformance.lines };
      const SumPO = nextProps.purchasingPerformance.sum;
      const totalPriceByPO = nextProps.purchasingPerformance.Sum_Total_Price;
      const finalPriceByPO = nextProps.purchasingPerformance.Sum_Final_Price;
      const totalPriceByProd = nextProps.purchasingPerformance.sum_total_price;
      const totalQtyByProd = nextProps.purchasingPerformance.Sum_Total_Quantity;
      const totalQty = nextProps.purchasingPerformance.sum_quantity;
      const totalWt = nextProps.purchasingPerformance.sum_weight;
      const receiveTotalQtyByProd = nextProps.purchasingPerformance.Sum_Receive_Total_Quantity;
      if (this.state.activeKey === 1) {
        this.setState({ purchasingPerformance, totalPriceByPO, finalPriceByPO, SumPO });
      } else {
        this.setState({ purchasingPerformanceByProducts: purchasingPerformance, totalPriceByProd, totalQty, totalWt, SumPO, totalQtyByProd, receiveTotalQtyByProd });
      }
    }

    if (nextProps.purchaseOrderPerformanceByProduct && nextProps.purchaseOrderPerformanceByProduct != this.props.purchaseOrderPerformanceByProduct) {
      const purchasingPerformanceByProducts = { ...this.state.purchasingPerformanceByProducts, rows: nextProps.purchaseOrderPerformanceByProduct.lines };
      const SumPO = nextProps.purchaseOrderPerformanceByProduct.sum;
      this.setState({ purchasingPerformanceByProducts, SumPO });
    }
    if (nextProps.purchasingPerformanceByProducts && nextProps.purchasingPerformanceByProducts != this.props.purchasingPerformanceByProducts) {
      const totalPriceByProd = nextProps.purchasingPerformanceByProducts.sum_total_price;
      const totalQty = nextProps.purchasingPerformanceByProducts.sum_quantity;
      const totalWt = nextProps.purchasingPerformanceByProducts.sum_weight;
      const purchasingPerformanceByProducts = { ...nextProps.purchasingPerformanceByProducts, rows: nextProps.purchasingPerformanceByProducts.lines };
      this.setState({ purchasingPerformanceByProducts, totalPriceByProd, totalQty, totalWt });
    }

    if (nextProps.purchaseOrderList && nextProps.purchaseOrderList != this.props.purchaseOrderList) {
      const purchaseOrderDetail = { ...this.state.purchaseOrderDetail, rows: nextProps.purchaseOrderList };
      this.setState({ purchaseOrderDetail });
    }
    if (nextProps.days && nextProps.days != this.props.days) {
      if (nextProps.days !== '-1') {
        this.resetDateRange();
      }
      this.setState({ days: nextProps.days });
    }
    if (nextProps.fromDate && nextProps.fromDate !== this.props.fromDate) {
      // pass async callback for fetching with new filter
      this.setState({ fromDate: nextProps.fromDate }, this.fetchPurchasingPerformanceByDays);
    }
    if (nextProps.toDate && nextProps.toDate !== this.props.toDate) {
      // pass async callback for fetching with new filter
      this.setState({ toDate: nextProps.toDate }, this.fetchPurchasingPerformanceByDays);
    }
    if (nextProps.selectedWarehouse.value != this.props.selectedWarehouse.value) {
      if ((isLAP || isAPD)) {
        this.fetchListWithFilters(nextProps.selectedWarehouse.value);
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let productDepartment_id = this.state.currentDep;
    const productGroup_id = this.state.currentGroup;
    const productCategory_id = this.state.currentCategory;
    const groups = document.getElementsByName('group');
    let i = 0;
    for (; i < groups.length; i++) {
      if (groups[i].id !== `g${productGroup_id}`) {
        groups[i].style.backgroundColor = null;
      } else {
        groups[i].style.backgroundColor = APP_COLORS['active-category-background-nav'];
      }
    }

    const categories = document.getElementsByName('category');
    i = 0;
    if (categories) {
      for (; i < categories.length; i++) {
        if (categories[i].id !== `c${productCategory_id}`) {
          categories[i].style.backgroundColor = null;
        } else {
          categories[i].style.backgroundColor = APP_COLORS['active-category-background-nav'];
        }
      }
    }

    const deps = document.getElementsByName('dep');
    i = 0;
    for (; i < deps.length; i++) {
      if (deps[i].id !== `d${productDepartment_id}`) {
        deps[i].style.backgroundColor = null;
      } else {
        deps[i].style.backgroundColor = APP_COLORS['active-category-background-nav'];
      }
    }
    if (!this.props.searchType) {
      this.props.setDefaultSearchType('RefNum', 'purchasingPerformance');
    }
    if (prevProps.Vendor_id !== this.props.Vendor_id) {
      let fromDate = '1900-01-01';
      let toDate = '3000-01-01';
      if (this.state.fromDate) {
        fromDate = this.formatDate(this.state.fromDate);
      }
      if (this.state.toDate) {
        toDate = this.formatDate(this.state.toDate);
      }
      if (!this.props.Vendor_id && this.state.activeKey == '1') {
        this.resetByPurchaseOrderData();
        this.fetchListWithFilters();
      } else {
        this.fetchListWithFilters();
        // this.props.fetchPurchasePerformanceByFilter(this.state.days, fromDate, toDate, 'show', this.state.POStatus, nextProps.Vendor_id);
      }
    }
    if (prevProps.purchaser_id !== this.props.purchaser_id) {
      this.fetchListWithFilters();
    }
    if (prevProps.selectedCompany !== this.props.selectedCompany) {
      this.props.fetchVendors(checkPermission('vendors_manager') ? {Company_id: undefined} : {});
      this.props.changeFormValue('purchasingPerformance', 'Vendor_id', null);
      // this.fetchListWithFilters();
    }
    if (isGGI && prevProps.selectedCompany.value === this.props.selectedCompany.value && prevProps.selectedWarehouse !== this.props.selectedWarehouse) {
      this.fetchListWithFilters();
    }
  }

  renderDatePickers() {
    if (this.state.days == -1) {
      return (
        <div className="form-group date-picker-positioner">
          <label className="col-xs-2 from-label col-xs-offset-5">
            <Translate value="from" />
          </label>
          <div className="col-xs-2 control-date-picker">
            <Field name="fromDate" component={DatePicker} maxDate={this.state.toDate || new Date()} />
          </div>
          <label className="col-xs-1 to-label">
            <Translate value="to" />
          </label>
          <div className="col-xs-2 control-date-picker">
            <Field name="toDate" component={DatePicker} minDate={this.state.fromDate || new Date('2016-01-01')} />
          </div>
        </div>
      );
    }
  }

  handleSelect(activeKey) {
    switch (activeKey) {
      case 1:
        this.setState({ activeKey });
        break;
      default:
        this.setState({ activeKey });
    }
  }

  handleOptionChange = (changeEvent) => {
    this.setState({ productSearchType: changeEvent.target.value });
  }

  // Used for new generic datePicker//////////////////////////////
  setToDate = (e) => {
    if (e < this.state.fromDate) {
      return;
    }
    this.setState({ toDate: e });
  }

  setFromDate = (e) => {
    if (e > this.state.toDate) {
      return;
    }
    this.setState({ fromDate: e });
  }

  setToRangeSearch = (e) => {
    this.setState({ days: '-1' });
  }
  //////////////////////////////

  formatDate(date) {
    return dateFormat('YYYY-MM-DD', date);
  }

  getVendorOptions() {
    const vendorOptions = [];
    this.props.vendors.map((vendor) => {
      vendorOptions.push({ value: vendor.Vendor_id, label: `${vendor.VendorNum} - ${vendor.Name}` });
    });
    return vendorOptions;
  }

  resetDateRange() {
    this.props.setDefaultOfForm('fromDate', null, 'purchasingPerformance');
    this.props.setDefaultOfForm('toDate', null, 'purchasingPerformance');
  }

  resetByPurchaseOrderData(callback) {
    this.setState(prevState => ({
      ...prevState,
      purchasingPerformance: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      purchaseOrderDetail: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      totalPriceByPO: 0,
      finalPriceByPO: 0,
    }), callback);
  }

  fetchPurchasingPerformanceByDays(days) {
    let fromDate = '1900-01-01';
    let toDate = '3000-01-01';
    const productinfo = this.state.filterProductID;
    if (this.state.fromDate) {
      fromDate = this.formatDate(this.state.fromDate);
    }
    if (this.state.toDate) {
      toDate = this.formatDate(this.state.toDate);
    }
    if (this.state.activeKey === 1) {
      if (days === '-1' || days === -1) {
        this.setState({ days: days }, () => {
          this.fetchListWithFilters();
          // this.props.fetchPurchasePerformanceByFilter(days, fromDate, toDate, 'show', this.state.POStatus, this.props.Vendor_id);
        })
      } else {
        this.setState({ days:days, fromDate: undefined, toDate: undefined }, () => {
          this.fetchListWithFilters();
          // this.props.fetchPurchasePerformanceByFilter(days, fromDate, toDate, 'show', this.state.POStatus, this.props.Vendor_id);
        });
      }
    } else if (this.state.activeKey === 2 && productinfo) {
      if (days === '-1' || days === -1) {
        this.setState({ days: days }, () => {
          this.fetchListWithFilters();
          // this.props.fetchPurchasePerformanceByFilter(days, fromDate, toDate, 'show', this.state.POStatus, null, productinfo);
        })
      } else {
        this.setState({ days:days, fromDate: undefined, toDate: undefined }, () => {
          this.fetchListWithFilters();
          // this.props.fetchPurchasePerformanceByFilter(days, fromDate, toDate, 'show', this.state.POStatus, null, productinfo);
        });
      }
    }
  }

  fetchPurchasingPerformanceByStatus(poStatus) {
    let fromDate = '1900-01-01';
    let toDate = '3000-01-01';
    const productinfo = this.state.filterProductID;
    if (this.state.fromDate) {
      fromDate = this.formatDate(this.state.fromDate);
    }
    if (this.state.toDate) {
      toDate = this.formatDate(this.state.toDate);
    }
    if (this.state.activeKey === 1) {
      this.setState(
        { POStatus: poStatus },
        () => {
          this.fetchListWithFilters();
        }
      );
    } else if (this.state.activeKey === 2 && productinfo) {
      this.setState(
        { POStatus: poStatus },
        () => {
          this.fetchListWithFilters()
        }
      );
    }
  }

  fetchListWithFilters = (selectedWarehouse) => {
    let fromDate = '1900-01-01';
    let toDate = '3000-01-01';
    const productinfo = this.state.filterProductID;
    let department = this.state.currentDep;
    let group = this.state.currentGroup;
    let category = this.state.currentCategory;
    let checkedDepKeys = Array.from(new Set(this.state.checkedDepKeys));
    let checkedGroupKeys = Array.from(new Set(this.state.checkedGroupKeys));
    let checkedCategoryKeys = Array.from(new Set(this.state.checkedCategoryKeys));
    if (department === -1 && this.state.checkable) {
      this.setState({
        checkedDepKeys: [],
        checkedGroupKeys: [],
        checkedCategoryKeys: []
      })

    }
    if (this.state.fromDate) {
      fromDate = this.formatDate(this.state.fromDate);
    }
    if (this.state.toDate) {
      toDate = this.formatDate(this.state.toDate);
    }
    let sq = new Date().getTimezoneOffset();
    let time = -sq / 60;
    let purchaser_id = this.props.purchaser_id && this.props.purchaser_id.value ? this.props.purchaser_id.value === 'All' ? 0 : this.props.purchaser_id.value : this.props.purchaser_id
    let singleDep = group && group !== -1 || category && category !== -1 ? null : department === -1 ? null : department;
    let multiDep = department === -1 ? null : checkedDepKeys.join(',')
    let singleGroup = category && category !== -1 ? null : group === -1 ? null : group;
    let multiGroup = department === -1 ? null : checkedGroupKeys.join(',')
    let singleCategory = category === -1 ? null : category;
    let multiCategory = department === -1 ? null : checkedCategoryKeys.join(',')
    const addtionalParams = {
      warehouse_id: selectedWarehouse ? selectedWarehouse : this.props.selectedWarehouse.value,
      company_id: this.props.selectedCompany.value,
      buyer_id: this.state.selectedBuyer === 'All' ? 0 : this.state.selectedBuyer,
      purchaser_id,
      time_diff: time, 
      product_department_ids: this.state.checkable ? multiDep : singleDep,
      product_group_ids: this.state.checkable ? multiGroup : singleGroup,
      product_category_ids: this.state.checkable ? multiCategory : singleCategory,
      is_aggregate: this.state.hide ? this.state.hide : null,
      product_num: productinfo ? productinfo : null
    };
    if (isOCM) {
      addtionalParams.IsTransfer = false;
      addtionalParams.IsRelocation = false;
    }
    if (this.state.orderType) {
      addtionalParams[this.state.orderType] = true;
    }
    if (this.state.activeKey === 1 ) {
      this.props.fetchPurchasePerformanceByFilterGFD(this.state.days, fromDate, toDate, 'show', this.state.POStatus, this.props.Vendor_id, null, addtionalParams);
    } else if (this.state.activeKey === 2 && productinfo) {
      this.props.fetchPurchasePerformanceByFilterGFD(this.state.days, fromDate, toDate, 'show', this.state.POStatus, null, productinfo, addtionalParams);
    }
  }

  handleFetchPurchasePerformanceByProduct = (ProductNum) => {
    let fromDate = '1900-01-01';
    let toDate = '3000-01-01';
    if (this.state.fromDate) {
      fromDate = this.formatDate(this.state.fromDate);
    }
    if (this.state.toDate) {
      toDate = this.formatDate(this.state.toDate);
    }
    this.setState({ filteredByItem: true, filterProductID: ProductNum }, () => {
      this.fetchListWithFilters();
    });
    // this.props.fetchPurchasePerformanceByFilter(this.props.days, fromDate, toDate, 'show', this.state.POStatus, null, ProductNum);
  }

  openShowInventory(event) {
    if (!(this.props.allProducts) || (this.props.allProducts == '')) {
      return;
    }
    switch (event.charCode) {
      case 13: // ENTER
        event.preventDefault();
        this.setState({ showInventoryOpen: true });
        break;
    }
  }


  closeShowInventory(value) {
    this.setState({ showInventoryOpen: false });
  }

  selectInventoryInfo(selectedInventoryRow) {
    this.setState({ ProductNum: selectedInventoryRow });
  }

  setUnitPrice(unitPrice) {
  }

  setAllProductQuantity(quantity) {
  }

  renderTable() {
    const tableHeight = (window.innerHeight < 930) ? 300 : 300;
    if (this.props.purchasingPerformanceIsLoading && !this.props.purchasingPerformanceError) {
      return (
        <div id="spinner" style={{ minHeight: tableHeight }}>
          <Spinner />
        </div>
      );
    } else
    if (this.props.purchasingPerformanceError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.purchasingPerformanceError)}</div>
        </ContentWrapper>
      );
    }

    // Parameters of the react-data-grid
    const getRows = () => Data.Selectors.getRows(this.state.purchasingPerformance);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function

    const handleGridSort = (sortColumn, sortDirection) => {
      const purchasingPerformance = Object.assign({}, this.state.purchasingPerformance, { sortColumn, sortDirection });
      this.setState({ purchasingPerformance });
    };

    const onRowClick = (rowIdx, row) => {
      if (rowIdx != -1) {
        const rows = getRows();
        this.setState({ rows, selectedRows: [rows[rowIdx]] });
        this.props.fetchPurchaseOrderList(row.PurchaseOrder_id);
      }
    };

    const onRowsSelected = (rows) => {
      let newRows = this.state.purchasingPerformance.rows;
      rows.map(r => {
        newRows[r.rowIdx].isSelected = true;
      });
      const purchasingPerformance = { ...this.state.purchasingPerformance, rows: newRows };
      this.setState({ purchasingPerformance });
    }
    const onRowsDeselected = (rows) => {
      let newRows = this.state.purchasingPerformance.rows;
      rows.map(r => {
        newRows[r.rowIdx].isSelected = false;
      });
      const purchasingPerformance = { ...this.state.purchasingPerformance, rows: newRows };
      this.setState({ purchasingPerformance });
    }
    // Column difinition
    const columns = [
      {
        key: 'PONum',
        name: <Translate value="po_num" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      ...(isLAP || isAPD) ? [
        {
          key: 'VendorNum',
          name: <Translate value="vendor_no" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'VendorName',
          name: <Translate value="vendor_name" />,
          resizable: true,
          sortable: true,
          width: 140,
          filterable: true,
        },
      ]:[],
      {
        key: 'OrderDate',
        name: <Translate value="order_date" />,
        resizable: true,
        sortable: true,
        width: 90,
        formatter: DateFormatter,
      },
      {
        key: 'TotalPrice',
        name: <Translate value="order_total" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: CashFormatter,
      },
      {
        key: 'FinalPrice',
        name: <Translate value="order_final" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: CashFormatter,
      },
      {
        key: 'ReceiveDate',
        name: <Translate value="rcv_date" />,
        resizable: true,
        sortable: true,
        width: 90,
        formatter: DateFormatter,
      },
      {
        key: 'ReceiveTotalPrice',
        name: <Translate value="rcv_total" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: CashFormatter,
      },
      {
        key: 'ReceiveFinalPrice',
        name: <Translate value="rcv_final" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: CashFormatter,
      },
      ...(isLAP || isAPD) ? [
        {
          key: 'ReturnFinalPrice',
          name: <Translate value="return_final_price" />,
          resizable: true,
          sortable: true,
          width: 100,
          formatter: CashFormatter,
        },
        {
          key: 'LastReturnDate',
          name: <Translate value="rtn_date" />,
          resizable: true,
          sortable: true,
          width: 100,
          formatter: DateFormatter,
        },
      ]:[],
      {
        key: 'PurchaseStatus',
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 110,
        formatter: ({ value }) => (
          <div>
            {isVAK ? value === 'Placed' ? <Translate value="po_placed" /> : <Translate value={value} /> : value}
          </div>
        ),
      },
      {
        key: 'Purchaser',
        name: <Translate value="purchaser" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
    ];

    // React Table Purchase Order Full Table
    return (
      <Col sm={12}>
        {(getSize() === 0) && (<span className="alert-danger"><Translate value="no_data_found" /></span>)}
        <div className="react-table-purchasing-performance" id="PurchasingPerformance-dataGrid1">
          <ReactDataGrid
            enableRowSelect={(isLAP || isAPD) ? "multi" : "single"}
            onGridSort={handleGridSort}
            columns={columns}
            rowHeight={25}
            headerRowHeight={45}
            onRowClick={onRowClick}
            rowGetter={rowGetter}
            rowsCount={getSize()}
            minHeight={tableHeight}
            rowSelection = {{
              showCheckbox: true,
              enableShiftSelect: true,
              onRowsSelected,
              onRowsDeselected,
              selectBy: {
                isSelectedKey: "isSelected",
              },
            }}
          />
        </div>
      </Col>
    );
  }


  renderProductsTableList() {
    if (this.props.purchaseOrderListIsLoading && !this.props.purchaseOrderListError) return <Spinner />;
    else if (this.props.purchaseOrderListError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.purchaseOrderListError)}
          </div>
        </ContentWrapper>);
    }

    // Parameters of the react-data-grid
    const tableHeight = (window.innerHeight < 930) ? 185 : 185;

    const getRows = () => Data.Selectors.getRows(this.state.purchaseOrderDetail);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.purchaseOrderDetail, { sortColumn, sortDirection });
      this.setState({ purchaseOrderDetail: state });
    };

    const onClearFilters = () => {
      // all filters removed
      const purchaseOrderDetail = { ...this.state.purchaseOrderDetail, filters: {} };
      this.setState({ purchaseOrderDetail });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.purchaseOrderDetail.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const purchaseOrderDetail = { ...this.state.purchaseOrderDetail, filters: newFilters };
      this.setState({ purchaseOrderDetail });
    };

    // Handle the row select function
    const onRowSelect = (rows) => {
      const purchaseOrderDetail = { ...this.state.purchaseOrderDetail, selectedRows: rows };
      this.setState({ purchaseOrderDetail });
    };

    const VendorNameFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value.Name}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    const VendorNumFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    // Column definition
    const columns = [
      ...isOLG ? [] : [{
        key: 'ProductNum',
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      }],
      {
        key: 'RefNum',
        name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: 'Name',
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 250,
      },
      {
        key: 'Description',
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 200,
      },
      {
        key: 'expire_date',
        name: <Translate value="expire_date" />,
        resizable: true,
        sortable: true,
        width: 80,
      },
      {
        key: 'PackageType',
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: 'OrderQuantity',
        name: <Translate value="order_qty" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: 'OrderTotalNetWeight',
        name: <Translate value="order_wt" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: 'OrderUnitPrice',
        name: <Translate value="order_unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: 'OrderTotalPrice',
        name: <Translate value="order_total_dollarsign" />,
        resizable: true,
        width: 80,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: 'ReceiveQuantity',
        name: <Translate value="receive_qty" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: 'ReceiveTotalWeight',
        name: <Translate value="receive_wt" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: 'ReceiveUnitPrice',
        name: <Translate value="receive_unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: 'ReceiveTotalPrice',
        name: <Translate value="receive_total_dollarsign" />,
        resizable: true,
        width: 80,
        sortable: true,
        formatter: CashFormatter,
      },
      ...(isLAP || isAPD) ? [
        {
          key: 'Rtn_Quantity',
          name: <Translate value="rtn_qty" />,
          resizable: true,
          sortable: true,
          width: 100,
        },
        {
          key: 'Rtn_Weights',
          name: <Translate value="rtn_weight" />,
          resizable: true,
          sortable: true,
          width: 100,
        },
        {
          key: 'Rtn_Total_price',
          name: <Translate value="return_final_price" />,
          resizable: true,
          sortable: true,
          width: 100,
          formatter: CashFormatter,
        },
        {
          key: 'Rtn_LastDate',
          name: <Translate value="rtn_date" />,
          resizable: true,
          sortable: true,
          width: 100,
          formatter: DateFormatter,
        },
      ]:[],
    ];

    // React Table Purchase Order Details
    return (
      <Col xs={12}>
        <div className="recat-customizer" id="PurchasingPerformance-dataGrid2">
          <ReactDataGrid
            onGridSort={handleGridSort}
            onAddFilter={handleFilterChange}
            onClearFilters={onClearFilters}
            columns={columns}
            rowGetter={rowGetter}
            rowsCount={getSize()}
            rowHeight={25}
            headerRowHeight={45}
            minHeight={tableHeight}
            onRowSelect={onRowSelect}
          />
        </div>
      </Col>
    );
  }

  renderByProductTable() {
    const tableHeight = (window.innerHeight < 930) ? 470 : 470;

    if (this.props.purchasingPerformanceIsLoading && !this.props.purchasingPerformanceError) {
      return (
        <div id="spinner" style={{ minHeight: tableHeight }}>
          <Spinner />
        </div>
      );
    } else if (this.props.purchasingPerformanceError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.purchasingPerformanceError)}</div>
        </ContentWrapper>
      );
    }

    // Parameters of the react-data-grid
    const getRows = () => Data.Selectors.getRows(this.state.purchasingPerformanceByProducts);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const purchasingPerformanceByProducts = Object.assign({}, this.state.purchasingPerformanceByProducts, { sortColumn, sortDirection });
      this.setState({ purchasingPerformanceByProducts });
    };

    // Column difinition
    const columns = [
      ...(this.state.hide) ? [] : [{
        key: 'order_num',
        name: <Translate value="order_num" />,
        resizable: true,
        sortable: true,
        width: 92,
      }],
      {
        key: 'related_product_num',
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: 'related_product_ref_num',
        name: <Translate value="product_ref_num" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: 'related_product_name',
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      // {
      //   key: 'related_product_group_name',
      //   name: <Translate value="product_group_name" />,
      //   resizable: true,
      //   sortable: true,
      //   width: 110,
      // },
      {
        key: 'related_product_description',
        name: <Translate value="product_description" />,
        resizable: true,
        sortable: true,
        width: 110,
      },
      {
        key: 'order_quantity',
        name: <Translate value="qty" />,
        resizable: true,
        sortable: true,
        width: 80,
      },
      {
        key: 'order_weight',
        name: <Translate value="wt" />,
        resizable: true,
        sortable: true,
        width: 80,
      },
      {
        key: 'avg_unit_price',
        name: <Translate value="unit_price_dollar" />,
        resizable: true,
        sortable: true,
        width: 80,
      },
      {
        key: 'order_total_cost',
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 112,
        formatter: CashFormatter,
      },
      ...(this.state.hide) ? [] : [{
        key: 'vendor_num',
        name: <Translate value="vendor_no" />,
        resizable: true,
        sortable: true,
        width: 130,
      },
      {
        key: 'vendor_name',
        name: <Translate value="vendor_name" />,
        resizable: true,
        sortable: true,
        width: 130,
      }],
      ...(this.state.hide) ? [] : [{
        key: 'post_date',
        name: <Translate value="date" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: DateFormatter,
      },
      {
        key: 'purchaser_name',
        name: <Translate value="purchaser" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: 'line_notation',
        name: <Translate value="notation" />,
        resizable: true,
        sortable: true,
        width: 100,
      }],
    ];

    // React Table Purchase Order Full Table
    return (
      <Row>
        <Col sm={12}>
          {(getSize() === 0) && (<span className="alert-danger"><Translate value="no_data_found" /></span>)}
          <div className="react-table-purchasing-performance-by-product" id="PurchasingPerformance-dataGrid3">
            <ReactDataGrid
              enableCellSelect
              onGridSort={handleGridSort}
              columns={columns}
              rowHeight={25}
              headerRowHeight={45}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              minHeight={tableHeight}
            />
          </div>
        </Col>
      </Row>
    );
  }

  handleClickDep(dep, id) {
    this.props.setDefaultOfForm('ProductNum', null, 'salesPerformance');
    let depExpanded = this.state.depExpanded;
    let fromDate = '1900-01-01';
    let toDate = '3000-01-01';
    let store = this.props.Store;
    if (store) {
      store = store.value || store;
    }
    if (this.state.fromDate) {
      fromDate = this.formatDate(this.state.fromDate);
    }
    if (this.state.toDate) {
      toDate = this.formatDate(this.state.toDate);
    }
    const productNum = null;
    let seller = this.props.Seller;
    if (this.props.Seller) { seller = this.props.Seller.value; }
    let customer = this.props.Customer;
    if (this.props.Customer) { customer = this.props.Customer.value; }
    if (dep && this.state.currentDep === dep.ProductDepartment_id) {
      this.setState({ depExpanded: !depExpanded });
      if (!depExpanded) {
        this.setState({ currentGroup: null, currentCategory: -1, filteredByItem: false, filterProductID: null, suggestValue: '' });
        this.fetchListWithFilters();
        // this.props.fetchGroupCategories(group.ProductGroup_id);
        this.props.fetchDepCategories(dep.ProductDepartment_id);
      } else {
        this.fetchListWithFilters();
      }
    } else if (dep) {
      this.setState({ currentDep: dep.ProductDepartment_id, depExpanded: true, currentGroup: null, currentCategory: -1, filteredByItem: false, filterProductID: null, suggestValue: '' }, () => {
        this.fetchListWithFilters();
      });
      this.props.fetchDepCategories(dep.ProductDepartment_id);
    } else {
      this.setState({ currentDep: -1, currentGroup: null, currentCategory: -1, filteredByItem: false, filterProductID: null, suggestValue: '' }, () => {
        this.fetchListWithFilters();
      });
    }
  }

  fetchDepartmentLocal(selectedBuyer) {
    let url = `${PRODUCT_DEP_URL}?nested=True`;
    if (selectedBuyer && selectedBuyer !== 'All') {
      url = `${PRODUCT_DEP_URL}?nested=True&BuyerId=${selectedBuyer}`
    }
    axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((response) => {
        if (response.error) {
          alert(JSON.stringify(response.error));
        } else {
          this.props.fetchDepsSuccess(response.data)
        }
    });
  }

  handleBuyerChange(selectedBuyer) {
    this.setState({selectedBuyer});
    // this.fetchDepartmentLocal(selectedBuyer);
    this.setState({ currentDep: -1, currentGroup: null, currentCategory: -1, rows: [] });
    this.props.fetchDeps(selectedBuyer);
    this.fetchListWithFilters()
  }

  handleClickGroup(group, id) {
    this.props.setDefaultOfForm('ProductNum', null, 'salesPerformance');
    const groupExpanded = this.state.groupExpanded;
    let fromDate = '1900-01-01';
    let toDate = '3000-01-01';
    let store = this.props.Store;
    if (store) {
      store = store.value || store;
    }
    if (this.state.fromDate) {
      fromDate = this.formatDate(this.state.fromDate);
    }
    if (this.state.toDate) {
      toDate = this.formatDate(this.state.toDate);
    }
    const productNum = null;
    let seller = this.props.Seller;
    if (this.props.Seller) { seller = this.props.Seller.value; }
    let customer = this.props.Customer;
    if (this.props.Customer) { customer = this.props.Customer.value; }
    if (group && this.state.currentGroup === group.ProductGroup_id) {
      this.setState({ groupExpanded: !groupExpanded });
      if (!groupExpanded) {
        this.setState({ currentCategory: -1, filteredByItem: false, filterProductID: null, suggestValue: '' });
        // this.fetchListWithFilters();
        this.props.fetchGroupCategories(group.ProductGroup_id);
      }
      else {
        this.fetchListWithFilters();
      }
    } else if (group) {
      this.setState({ currentGroup: group.ProductGroup_id, groupExpanded: true, currentCategory: -1, filteredByItem: false, filterProductID: null, suggestValue: '' }, () => {
        this.fetchListWithFilters();
      });
      this.props.fetchGroupCategories(group.ProductGroup_id, '', isCCW ? true : false);
    } else {
      this.setState({ currentGroup: -1, currentCategory: -1, filteredByItem: false, filterProductID: null, suggestValue: '' }, () => {
        this.fetchListWithFilters();
      });
    }
  }

  handleClickCategory(id, checkFlag) {
    this.props.setDefaultOfForm('ProductNum', null, 'salesPerformance');
    let fromDate = '1900-01-01';
    let toDate = '3000-01-01';
    let store = this.props.Store;
    if (store) {
      store = store.value || store;
    }
    if (this.state.fromDate) {
      fromDate = this.formatDate(this.state.fromDate);
    }
    if (this.state.toDate) {
      toDate = this.formatDate(this.state.toDate);
    }
    const productNum = null;
    let seller = this.props.Seller;
    if (this.props.Seller) { seller = this.props.Seller.value; }
    let customer = this.props.Customer;
    if (this.props.Customer) { customer = this.props.Customer.value; }
    this.setState({ currentCategory: id }, () => {
      this.fetchListWithFilters();
    });
  }

  renderDeps() {
    if (!this.props.deps) return;
    const deps = this.props.deps;
    let { checkedDepKeys, checkedGroupKeys } = this.state
    return deps.map((dep) => {
      // let GroupNum = parseInt(group.GroupNum);
      // if (GroupNum < 10) GroupNum = `0${GroupNum}`;
      let description = 'Misc';
      if (localStorage.getItem('lang') === 'ch') {
        description = 'Description';
      } else if (localStorage.getItem('lang') === 'en') {
        description = 'Name';
      }
      return (
        <Panel className="panelStyle" >
          <div style={{ color: 'purple', marginLeft: '-5px', fontSize: '13px', fontFamily: 'Arial Black', cursor: 'pointer', paddingBottom: 0 }} name="dep" id={`d${dep.ProductDepartment_id}`} onClick={this.handleClickDep.bind(this, dep, `d${dep.ProductDepartment_id}`)}>
            {this.state.checkable && <input
              type="checkbox"
              name="salesPerformance"
              checked={checkedDepKeys.includes(dep.ProductDepartment_id)}
              onClick={
                (e) => {
                  e.stopPropagation()
                  if (e.target.checked) {
                    if (!checkedDepKeys.includes(dep.ProductDepartment_id)) {
                      checkedDepKeys.push(dep.ProductDepartment_id)
                      this.state.currentDep = dep.ProductDepartment_id
                      this.setState({ currentDep: dep.ProductDepartment_id, checkedDepKeys, checkedDepKeysCopy: [...checkedDepKeys] }, debounce(() => {
                        this.handleClickDep(dep, 'true')
                    }, 500))
                    }
                  }else {
                    checkedDepKeys = checkedDepKeys.filter(item => item !== dep.ProductDepartment_id)
                    this.props.groups.map(groupItem => {
                      if (groupItem.ProductDepartment_id_id === dep.ProductDepartment_id) {
                        checkedGroupKeys = checkedGroupKeys.filter(item => item !== groupItem.ProductGroup_id)
                      }
                    })
                    this.setState({ checkedDepKeys, checkedDepKeysCopy: [...checkedDepKeys], checkedGroupKeys }, debounce(() => {
                        this.handleClickDep(dep, 'true')
                    }, 500))
                  }
                }
              }
            />}
            <label style={{ fontWeight: 'bold' }}></label> {' '}<Translate value={dep[description]} />
          </div>
          {this.renderGroupsGfd(dep.ProductDepartment_id)}
          {/* {this.renderCategories(group.ProductGroup_id)} */}
        </Panel>
      );
    });
    // }
  }

  renderGroupsGfd(dep_id) {
    if (!this.props.groups) return;
    const groups = this.props.groups;
    let { checkedDepKeys, checkedDepKeysCopy, checkedGroupKeys, checkedGroupKeysCopy, checkedCategoryKeys, } = this.state
    let description = 'Misc';
    if (localStorage.getItem('lang') === 'ch') {
      description = 'Description';
    } else if (localStorage.getItem('lang') === 'en') {
      description = 'Name';
    }

    if (this.state.currentDep === dep_id && this.state.depExpanded) {
      return groups.map(group => {
        if (checkedDepKeys.includes(group.ProductDepartment_id_id)) {
          checkedGroupKeys.push(group.ProductGroup_id)
        }
        this.state.checkedGroupKeys = checkedGroupKeys
        
        return (
          <div>
            <li className="clickListLi2" style={{ color: APP_COLORS['category-nav'], fontFamily: 'Arial Black', cursor: 'pointer' }} name="group" id={'g' + group.ProductGroup_id} onClick={this.handleClickGroup.bind(this, group, 'g' + group.ProductGroup_id)}>
              {this.state.checkable && <input
                type="checkbox"
                name="salesPerformance"
                checked={checkedGroupKeys.includes(group.ProductGroup_id)}
                onClick={
                  (e) => {
                    e.stopPropagation()
                    if (e.target.checked) {
                      if (!checkedGroupKeys.includes(group.ProductGroup_id)) {
                        checkedGroupKeys.push(group.ProductGroup_id)
                      }
                      this.setState({ checkedDepKeys, checkedDepKeysCopy, checkedGroupKeys, checkedGroupKeysCopy: [...checkedGroupKeys], checkedCategoryKeys }, debounce(() => {
                          this.handleClickGroup(group)
                      }, 500))
                    } else {
                      checkedGroupKeys = checkedGroupKeys.filter(item => item !== group.ProductGroup_id)
                      checkedDepKeys = checkedDepKeys.filter(item => item !== group.ProductDepartment_id_id)
                      if (this.props.groupCategories.length) {
                        this.props.groupCategories.map(categoryItem => {
                          checkedCategoryKeys = checkedCategoryKeys.filter(item => item !== categoryItem.ProductCategory_id)
                        })
                      } else {
                        checkedCategoryKeys = []
                      }
                     
                      this.setState({ checkedDepKeys, checkedDepKeysCopy: [...checkedDepKeys], checkedGroupKeys, checkedGroupKeysCopy: [...checkedGroupKeys], checkedCategoryKeys }, debounce(() => {
                          this.handleClickGroup(group, 'true')
                      }, 500))
                    }
                  }
                }
              />}
              <label style={{ fontWeight: 'bold' }}></label> {' '}<Translate value={group[description]} />
            </li>
            {this.renderCategories(group.ProductGroup_id)}
          </div>
        );
      })
    }
    return;
    // return groups.map((group) => {
    //   return (
    //     <Panel className="panelStyle" >
    //       <div style={{ color: APP_COLORS['category-nav'], fontFamily: 'Arial Black', cursor: 'pointer' }} name="group" id={`g${group.ProductGroup_id}`} onClick={this.handleClickGroup.bind(this, group, `g${group.ProductGroup_id}`)}>
    //         <label style={{ fontWeight: 'bold' }}></label> {' '}<Translate value={group[description]} />
    //       </div>
    //       {this.renderCategories(group.ProductGroup_id)}
    //     </Panel>
    //   );
    // });
  }

  renderCategories(group_id) {
    if (!this.props.groupCategories) return;
    const groupCategories = this.props.groupCategories;
    let { checkedDepKeys, checkedGroupKeys, checkedGroupKeysCopy, checkedCategoryKeys } = this.state
    let description;
    if (localStorage.getItem('lang') == 'ch') {
      description = 'Description';
    } else if (localStorage.getItem('lang') == 'en') {
      description = 'Name';
    }
    if (this.state.currentGroup === group_id && this.state.groupExpanded) {  
      return groupCategories.map(category => {
        if (checkedGroupKeys.includes(category.ProductGroup_id_id)) {
          checkedCategoryKeys.push(category.ProductCategory_id)
        } 
        this.state.checkedCategoryKeys = checkedCategoryKeys
        return (
        <li className="clickListLi" style={{ color: APP_COLORS['sub-category-nav'], fontFamily: 'Arial' }} name="category" id={`c${category.ProductCategory_id}`} onClick={this.handleClickCategory.bind(this, category.ProductCategory_id)}>
          {this.state.checkable && <input
            type="checkbox"
            name="salesPerformance"
            checked={checkedCategoryKeys.includes(category.ProductCategory_id)}
            onClick={
              (e) => {
                e.stopPropagation()
                if (e.target.checked) {
                  if (!checkedCategoryKeys.includes(category.ProductCategory_id)) {
                    checkedCategoryKeys.push(category.ProductCategory_id)
                  }
                  this.setState({ checkedGroupKeys, checkedGroupKeysCopy, checkedCategoryKeys }, debounce(() => {
                    this.handleClickCategory(category.ProductCategory_id)
                  }, 500)
                )
                }else {
                  checkedCategoryKeys = Array.from(new Set(checkedCategoryKeys)).filter(item => item !== category.ProductCategory_id)
                  checkedGroupKeys = Array.from(new Set(checkedGroupKeys)).filter(item => item !== category.ProductGroup_id_id)
                  checkedDepKeys = Array.from(new Set(checkedDepKeys)).filter(item => item !== this.state.currentDep)
                  this.setState({ checkedDepKeys, checkedGroupKeys, checkedGroupKeysCopy: [...checkedGroupKeys], checkedCategoryKeys, checkedCategoryKeysCopy: [...checkedCategoryKeys] }, debounce(() => {
                      this.handleClickCategory(category.ProductCategory_id)
                  }, 500)
                )
                }
              }
            }
          />}
          <label style={{ fontWeight: 'bold' }}>{category.CategoryNum}</label>{` ${category[description]}`}
        </li>
      )});
    }
  }

  renderAutoSuggest() {
    if (!this.state.filteredByItem) {
      return (
        <div className="control-dropdown">
          <GenericProductSuggest
            value={this.state.suggestValue}
            onChange={(e, { newValue }) => { this.setState({ suggestValue: newValue }); }}
            SearchType={this.state.productSearchType}
            fetchOrdersByProduct={this.handleFetchPurchasePerformanceByProduct}
            setProductNum={this.selectInventoryInfo}
          />
        </div>
      );
    }
    return (
      <div id="suggestion-box">
        {this.state.suggestValue}
        <em
          className="fa fa-times pull-right"
          onClick={() => {
            let purchasingPerformanceByProducts = { ...this.state.purchasingPerformanceByProducts, rows: [], selectedInventoryRow: [], sortColumn: null, sortDirection: null, selectedIndexes: [] };
            this.setState({
              filteredByItem: false,
              suggestValue: '',
              filterProductID: null,
              totalPriceByProd: 0,
              totalQtyByProd: 0,
              totalQty: 0,
              totalWt: 0,
              receiveTotalQtyByProd: 0,
              purchasingPerformanceByProducts
            }, () => {
              this.fetchListWithFilters();
            });
          }}
        />
      </div>
    );
  }

  renderShowDetails = () => (
    <div style={{ marginTop: '3px' }}>
      <label>
        <input
          style={{ 'font-size': '50px', zoom: '2', marginRight: '2px' }}
          type="checkbox"
          value="showdetails"
          checked={this.state.hide}
          onClick={this.handleShowDetailsChange}
        />
        <Translate value="hide_details" />
      </label>
    </div>
  )

  handleShowDetailsChange = () => {
    this.setState({ hide: !this.state.hide }, () => { this.fetchPurchasePerformance(this.state.days || 1) });
  }

  fetchPurchasePerformance(curDays, productSearch) {
    const days = curDays.toString();
    if (this.state.filteredByItem) {
      if (days === '-1' || days === -1) {
        this.setState({ days }, () => {
          this.handleFetchPurchasePerformanceByProduct(this.state.filterProductID);
        });
      } else {
        this.setState({ days, fromDate: undefined, toDate: undefined }, () => {
          this.handleFetchPurchasePerformanceByProduct(this.state.filterProductID);
        });
      }
      return;
    }
    if (days === '-1' || days === -1) {
      this.setState({ days }, () => {
        if (this.state.checkable) {
          this.fetchListWithFilters()
        } else {
          this.fetchListWithFilters()
        }
      });
    } else {
      this.setState({ days, fromDate: undefined, toDate: undefined }, () => {
        if (this.state.checkable) {
          this.fetchListWithFilters()
        } else {
          this.fetchListWithFilters()
        }
      });
    }
  }

  getDateByDays = (days, fromDate, toDate) => {
    let dateRange = -1;
    if (days != null) { dateRange = days; }
    const date = {
      fromDate: '',
      toDate: '',
    };
    let postingDateGT = fromDate || '1900-01-01';
    let postingDateLT = toDate || '3000-01-01';
    if (dateRange != -1) {
      postingDateLT = moment().format('YYYY-MM-DD');
      if (dateRange === '1') {
        postingDateGT = postingDateLT;
      } else if (dateRange === '7') {
        postingDateGT = moment().subtract('7', 'days').format('YYYY-MM-DD');
      } else if (dateRange == '30') {
        postingDateGT = moment().subtract('30', 'days').format('YYYY-MM-DD');
      } else if (dateRange == '90') {
        postingDateGT = moment().subtract('90', 'days').format('YYYY-MM-DD');
      }
    }
    date.fromDate = postingDateGT;
    date.toDate = postingDateLT;
    return date;
  }

  handleTypeFilterChange = (orderType) => {
    this.setState({
      orderType,
    }, () => {
      this.fetchListWithFilters();
    });
  }

  renderOrderTypeRadio = () => {
    if (!isOCM) return null;

    const config = {
      content: [
        {
          option: null,
          id: 'normal-radio-filter',
          name: 'typeFilterRadios',
          labelName: 'normal',
        },
        {
          option: 'IsRelocation',
          id: 'relocated-radio-filter',
          name: 'typeFilterRadios',
          labelName: 'relocated',
        },
        {
          option: 'IsTransfer',
          id: 'transfer-radio-filter',
          name: 'typeFilterRadios',
          labelName: 'transfer',
        }
      ],
      value: this.state.orderType,
      handleOnClick: this.handleTypeFilterChange,
      type: 'buttons',
    }

    return (
      <Row>
        <Col xs={2}>
          <h3 className="filter-title">
            <Translate value="order_type" />
            <span className="colon">:</span>
          </h3>
        </Col>
        <Col xs={10}>
          <div id="statusFilterRadios" className="form-horizontal">
            {genericRadioFilter(config)}
          </div>
        </Col>
      </Row>
    )
  }

  renderTotalQuantityField = () => {
    if (isOCM) {
      return <Row style={{marginTop: '10px'}}>
        <label className="col-xs-4"><Translate value="total_qty" /></label>
        <Col xs={5}>
          <Field name="SumPOQty" component={DisabledInputField} placeholder={this.state.totalQtyByProd} />
        </Col>
      </Row>;
    }
  }

  renderReceivedTotalQuantityField = () => {
    if (isOCM) {
      return <Row style={{marginTop: '10px'}}>
        <label className="col-xs-5"><Translate value="rcv_total_qty" /></label>
        <Col xs={5}>
          <Field name="SumPOQtyFinal" component={DisabledInputField} placeholder={this.state.receiveTotalQtyByProd} />
        </Col>
      </Row>;
    }
  }

  render() {
    const createDialogInventoryStyle = {
      height: '700px',
      width: '1000px',
      marginLeft: '-28%',
      marginTop: '-20%',
    };
    let { selectedBuyer, buyerOptions } = this.state;
    const renderByProduct = (<span className="tab-title-medium"><Translate value="by_product" /></span>);
    const renderByPO = (<span className="tab-title-medium"><Translate value="by_po" /></span>);
    const vendorOptions = this.getVendorOptions();
    let POStatus = this.state.POStatus;
    let warehouse_id = this.props.selectedWarehouse.value;
    let company_id = this.props.selectedCompany.value;
    let buyer_id = this.state.selectedBuyer === 'All' ? 0 : this.state.selectedBuyer;
    let purchaser_id = this.props.purchaser_id && this.props.purchaser_id.value ? this.props.purchaser_id.value === 'All' ? 0 : this.props.purchaser_id.value : this.props.purchaser_id
    let sq = new Date().getTimezoneOffset();
    let time = -sq / 60;
    let is_aggregate = this.state.hide ? this.state.hide : null;
    let department = this.state.currentDep;
    let group = this.state.currentGroup;
    let category = this.state.currentCategory;
    let checkedDepKeys = Array.from(new Set(this.state.checkedDepKeys));
    let checkedGroupKeys = Array.from(new Set(this.state.checkedGroupKeys));
    let checkedCategoryKeys = Array.from(new Set(this.state.checkedCategoryKeys));
    let singleDep = group && group !== -1 || category && category !== -1 ? null : department === -1 ? null : department;
    let multiDep = department === -1 ? null : checkedDepKeys.join(',')
    let singleGroup = category && category !== -1 ? null : group === -1 ? null : group;
    let multiGroup = department === -1 ? null : checkedGroupKeys.join(',')
    let singleCategory = category === -1 ? null : category;
    let multiCategory = department === -1 ? null : checkedCategoryKeys.join(',')
    let product_department_ids = this.state.checkable ? multiDep : singleDep;
    let product_group_ids = this.state.checkable ? multiGroup : singleGroup;
    let product_category_ids = this.state.checkable ? multiCategory : singleCategory;
    const days = this.state.days;
    let product_info = this.state.filterProductID;
    let fromDate = '1900-01-01';
    let toDate = '3000-01-01';
    let print_url = '';
    let excel_url = '';
    let statementUrl = ''
    if (this.state.fromDate) {
      fromDate = this.formatDate(this.state.fromDate);
    }
    if (this.state.toDate) {
      toDate = this.formatDate(this.state.toDate);
    }
    const dates = toFromDates(days, fromDate, toDate);
    fromDate = dates.fromDate;
    toDate = dates.toDate;
    let Vendor_id = this.props.Vendor_id;
    if (Vendor_id) {
      Vendor_id = Vendor_id.value || Vendor_id;
      Vendor_id = `&vendor_id=${Vendor_id}`;
    } else {
      Vendor_id = '';
    }
    if (POStatus) {
      POStatus = POStatus.value || POStatus;
      POStatus = `&order_type=${POStatus}`;
    } else {
      POStatus = '&order_type=All';
    }
    if (buyer_id || buyer_id === 0) {
      buyer_id = `&buyer_id=${buyer_id}`
    } else {
      buyer_id = ''
    }
    if (purchaser_id) {
      purchaser_id = `&purchaser_id=${purchaser_id}`
    } else {
      purchaser_id = ''
    }
    if (product_info) {
      product_info = product_info.value || product_info;
      product_info = `&product_num=${product_info}`;
    } else {
      product_info = '';
    }
    if (is_aggregate) {
      is_aggregate = `&is_aggregate=${is_aggregate}`;
    } else {
      is_aggregate = '';
    }
    if (product_department_ids) {
      product_department_ids = `&product_department_ids=${product_department_ids}`;
    } else {
      product_department_ids = '';
    }
    if (product_group_ids) {
      product_group_ids = `&product_group_ids=${product_group_ids}`;
    } else {
      product_group_ids = '';
    }
    if (product_category_ids) {
      product_category_ids = `&product_category_ids=${product_category_ids}`;
    } else {
      product_category_ids = '';
    }
    if (this.state.activeKey == 1) {
      fromDate = `start_date=${fromDate}`;
      toDate = `end_date=${toDate}`;
      let connectUrl = `?${fromDate}&${toDate}${POStatus
        }&Bearer=${localStorage.getItem('token')}${Vendor_id}&company_id=${company_id}&warehouse_id=${warehouse_id}${buyer_id}${purchaser_id}&time_diff=${time}${product_info}${is_aggregate}${product_department_ids}${product_group_ids}${product_category_ids}`
      print_url = `${PURCHASE_URL}new_performance/${connectUrl}&action=print`;
      excel_url = `${PURCHASE_URL}new_performance/${connectUrl}&action=export`;
      statementUrl = `${PURCHASE_URL}new_performance/${connectUrl}&action=print_group`;
    }
    return (
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="purchase_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="purchase_performance" />
          </Breadcrumb.Item>
        </Breadcrumb>
        <Grid id="purchasing-performance">
          {/* Date Range Pickers */}

          <Tabs activeKey={this.state.activeKey} justified onSelect={this.handleSelect}>
            {/* <Tab eventKey={1} title={renderByPO} style={{ height: '350px' }}>
              <Row className="table-filters-purchasing-performance">
                <Col xs={(isLAP || isAPD) ? 4 : 3}>
                  <ButtonToolbar>
                    <Button bsStyle="primary" href={print_url} disabled={(!(isLAP || isAPD) && !Vendor_id) || !this.state.purchasingPerformance.rows.length || !checkPermission('print_purchase_performance')}>
                      <em className="fa fa-print" /><Translate value="print" />
                    </Button>
                    <Button bsStyle="success" href={excel_url} disabled={(!(isLAP || isAPD) && !Vendor_id) || !this.state.purchasingPerformance.rows.length || !checkPermission('print_purchase_performance')}>
                      <em className="fa fa-download" /><Translate value="excel" />
                    </Button>
                    {
                      (isLAP || isAPD) && <Button bsStyle="success" href={excel_details_url} disabled={!this.state.purchasingPerformance.rows.length || !checkPermission('print_purchase_performance')}>
                      <em className="fa fa-download" /><Translate value="excel_with_details" />
                    </Button>
                    }
                  </ButtonToolbar>
                </Col>
                <Col xs={4}>
                  <label className="col-xs-4"><Translate value="vendor" /></label>
                  <Col xs={8}>
                    <Field name="Vendor_id" component={Selection} options={vendorOptions} matchPos="any" />
                  </Col>
                </Col>
                <Col xs={3}>
                  <label className="col-xs-4"><Translate value="total_price" /></label>
                  <Col xs={5}>
                    <Field name="SumPO" component={DisabledInputField} placeholder={this.state.totalPriceByPO} />
                  </Col>
                </Col>
                <Col xs={(isLAP || isAPD) ? 2 : 3}>
                  <label className="col-xs-4"><Translate value="final_dollarsign" /></label>
                  <Col xs={5}>
                    <Field name="SumPOFinal" component={DisabledInputField} placeholder={this.state.finalPriceByPO} />
                  </Col>
                </Col>
              </Row>
              <br />
              <Row>
                { this.renderTable() }
              </Row>
              <br />
              <Row>
                { this.renderProductsTableList() }
              </Row>
            </Tab> */}
            <Tab eventKey={1}>
              <Row>
                <Col xs={2}>
                  <Panel id="category-nav" className="panelStyle" style={{height: '710px'}}>
                    {
                      this.state.checkable && <div style={{ color: APP_COLORS['sub-category-nav'], fontFamily: 'Arial', cursor: 'pointer', marginBottom: '5px', textAlign: 'right' }} onClick={() => {this.setState({checkable: false, checkedKeys: [], checkedChildKeys: []})}}>
                        <Translate value="prohibit_multi_select" />
                      </div>
                    }
                    {
                      !this.state.checkable && <div style={{ color: APP_COLORS['sub-category-nav'], fontFamily: 'Arial', cursor: 'pointer', marginBottom: '5px', textAlign: 'right' }} onClick={() => {this.setState({checkable: true})}}>
                        <Translate value="allows_multi_select" />
                      </div>
                    }
                    <div className="buyerGFD" style={{width: '80%', marginBottom: '10px'}}>
                      <GenericSelection
                        options={buyerOptions}
                        value={selectedBuyer}
                        setSelected={(e) => { this.handleBuyerChange(e.value); this.setState({
                          checkedDepKeys: [],
                          checkedGroupKeys: [],
                          checkedCategoryKeys: []
                        }) }}
                        // disabled={this.props.gfdLoading}
                      />
                    </div>
                    <Panel className="panelStyle" >
                      <div style={{ color: APP_COLORS['category-nav'], fontWeight: 'bold', cursor: 'pointer', paddingBottom: 0 }} name="dep" id="d-1" onClick={this.handleClickDep.bind(this, null, '-1')}>
                        <Translate value="all" />
                      </div>
                    </Panel>
                    {this.renderDeps()}
                  </Panel>
                </Col>
                <Col xs={10}>
                  <Row>
                    <Col xs={12}>
                      <Panel id="date-range-picker" className="form-horizontal">
                        {this.renderOrderTypeRadio()}
                        <Row>
                          <Col xs={1}>
                            <h3 className="filter-title"><Translate value="filter" /><span className="colon">:</span></h3>
                          </Col>
                          <Col xs={11}>
                            <div id="statusFilterRadios" className="form-horizontal">
                              {
                                genericRadioFilter({
                                  content: [
                                    {
                                      option: 'All',
                                      id: 'all-radio-filter',
                                      name: 'statusFilterRadios',
                                      labelName: 'all',
                                    },
                                    {
                                      option: 'Received',
                                      id: 'received-radio-filter',
                                      name: 'statusFilterRadios',
                                      labelName: 'received',
                                    },
                                    {
                                      option: 'Return',
                                      id: 'return-radio-filter',
                                      name: 'statusFilterRadios',
                                      labelName: 'return',
                                    },
                                  ],
                                  value: this.state.POStatus,
                                  handleOnClick: this.fetchPurchasingPerformanceByStatus,
                                  type: 'buttons',
                                })
                              }
                            </div>
                          </Col>
                          {/* <Col xs={2}>
                            <h3 className="filter-title"><Translate value="order_date" /><span className="colon">:</span></h3>
                          </Col> */}
                          <Col xs={11} xsOffset={1}>
                            {
                              dateFilterRadios({
                                handleOnClick: this.fetchPurchasingPerformanceByDays,
                                setFromDate: this.setFromDate,
                                setToDate: this.setToDate,
                                setToRangeSearch: this.setToRangeSearch,
                                FromDate: this.state.fromDate,
                                ToDate: this.state.toDate,
                                Days: this.state.days,
                              })
                            }
                          </Col>
                        </Row>
                      </Panel>
                      {/* End Date Range Pickers */}
                    </Col>
                  </Row>
                  <Row className="table-filters-purchasing-performance" style={{ display: 'flex', marginTop: '5px' }}>
                    <Col xs={2}>
                      <ButtonToolbar>
                        <Button bsStyle="primary" href={print_url} disabled={!this.state.purchasingPerformanceByProducts.rows.length}>
                          <em className="fa fa-print" /><Translate value="print" />
                        </Button>
                        <Button bsStyle="success" href={excel_url} disabled={!this.state.purchasingPerformanceByProducts.rows.length}>
                          <em className="fa fa-download" /><Translate value="excel" />
                        </Button>
                        <Button
                          bsStyle="primary"
                          style={{marginTop: 4}}
                          href={statementUrl}
                          disabled={!this.props.Vendor_id || !this.props.Vendor_id.value}
                        >
                          <em className="fa fa-download" /><Translate value="statement" />
                        </Button>
                      </ButtonToolbar>
                    </Col>
                    <Col xs={10} className="p0">
                      <div id="autosuggest-div">
                        <Row style={{ height: '30px' }}>
                          <Col xs={12}>
                            <TypeRadios value={this.state.productSearchType} handleOptionChange={this.handleOptionChange} />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12}>
                            {this.renderAutoSuggest()}
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                  <Row style={{ display: 'flex', flexDirection: 'row', }}>
                    <div style={{ ...styles.titleLabel, width: '58px' }}>
                      <Translate value="total_qty" />
                    </div>
                    <div style={{ ...styles.titleField }}>
                      <Field name="sum_quantity" component={DisabledInputField} placeholder={this.state.totalQty} />
                    </div>
                    <div style={{ ...styles.titleLabel }}>
                      <Translate value="total_cost" />
                    </div>
                    <div style={{ ...styles.titleField }}>
                      <Field name="sum_total_price" component={DisabledInputField} placeholder={this.state.totalPriceByProd} />
                    </div>
                    <div style={{ ...styles.titleLabel }}>
                      <Translate value="total_wt" />
                    </div>
                    <div style={{ ...styles.titleField }}>
                      <Field name="sum_weight" component={DisabledInputField} placeholder={this.state.totalWt} />
                    </div>
                    <div style={{ ...styles.titleLabel }}>
                      <Translate value="purchaser" />
                    </div>
                    <div style={{ ...styles.titleField }}>
                      <Field name="purchaser_id" component={Selection} options={buyerOptions.filter(item => item.value !== "All")} matchPos="any" />
                    </div>
                    <div style={{ ...styles.titleLabel }}>
                      <Translate value="vendor" />
                    </div>
                    <div style={{ ...styles.titleField }}>
                      <Field name="Vendor_id" component={Selection} options={vendorOptions} matchPos="any" />
                    </div>
                    {this.renderShowDetails()}
                  </Row>
                  <br />
                  {this.renderByProductTable()}
                </Col>
              </Row>
            </Tab>
          </Tabs>
        </Grid>

        {/* Inventory List */}
        <SkyLightStateless
          dialogStyles={createDialogInventoryStyle}
          isVisible={this.state.showInventoryOpen}
          onCloseClicked={
            this.closeShowInventory}
          title="Select Inventory"
        >
          <InventoryInfo
            searchValue={this.props.allProducts}
            searchType={this.props.searchType}
            closeShowInventory={this.closeShowInventory}
            selectInventoryInfo={this.selectInventoryInfo}
            setAllProducts={this.props.setAllProducts}
            setUnitPrice={this.setUnitPrice}
            setAllProductQuantity={this.setAllProductQuantity}
            form="purchasingPerformance"
          />
        </SkyLightStateless>
        {/* End Inventory List */}
      </ContentWrapper>
    );
  }
}

export default PurchasingPerformanceNew;



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/purchasingPerformanceNew.jsx